module.exports = __webpack_public_path__ + "img/deliver.9be7aa40.svg";